import type { ReactNode } from 'react';

interface Props {
  title?: string;
  description?: string;
  children?: ReactNode;
  /** Rendered inside the header, right of the title. */
  aside?: ReactNode;
}

export function Card({ title, description, children, aside }: Props) {
  return (
    <section className="min-w-0 rounded-token border border-border bg-surface-2 p-4 sm:p-6">
      {(title || aside) && (
        <header className="flex flex-wrap items-start justify-between gap-2">
          {title && (
            <h2 className="text-base font-semibold text-fg sm:text-lg">{title}</h2>
          )}
          {aside}
        </header>
      )}
      {description && (
        <p className="mt-1 text-sm text-muted">{description}</p>
      )}
      {children && <div className="mt-4">{children}</div>}
    </section>
  );
}
